var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 6.002 4.622 5.021a.516.516 0 0 0 .754 0L13 6.002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAngleDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjk5OTI3IDYuMDAxNTlMNy42MjIzNCAxMS4wMjMxQzcuNjcwNjkgMTEuMDc0NiA3LjcyOTA4IDExLjExNTcgNy43OTM5IDExLjE0MzdDNy44NTg3MyAxMS4xNzE4IDcuOTI4NjMgMTEuMTg2MyA3Ljk5OTI3IDExLjE4NjNDOC4wNjk5MSAxMS4xODYzIDguMTM5OCAxMS4xNzE4IDguMjA0NjMgMTEuMTQzN0M4LjI2OTQ2IDExLjExNTcgOC4zMjc4NSAxMS4wNzQ2IDguMzc2MTkgMTEuMDIzMUwxMi45OTkzIDYuMDAxNTkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";